import React, { useEffect, useState, useRef } from "react";
// import Header from "../Components/Header/Header";
// import Footer from "../Components/Footer/Footer";
import ImageSlider from "../Components/ImageSlider/ImageSlider";
import { useStaticQuery, graphql } from "gatsby";
import Container from "../Components/UI/Container/Container";
import CountDowns from "../Components/Countdowns/CountDowns";

import BathroomImageWithHotspot from "../Components/ImageWithHotspot/BathroomImageWithHotspot";
import KitchenImageWithHotspot from "../Components/ImageWithHotspot/KitchenImageWithHotspot";
import LaundryImageWithHotspot from "../Components/ImageWithHotspot/LaundryImageWithHotspot";
import useScreenWidth from "../Hooks/useScreenWidth";
// import { StaticImage } from "gatsby-plugin-image";
import "./index.scss";
// import disableScroll from "disable-scroll";
import BowerModal from "../Components/BowerModal/BowerModal";
import styled from "styled-components";
import { parse } from "query-string";

// const AlternativeSection = styled.section`
//   margin: 20px 0;

//   & ul {
//     padding-left: 2em;
//     list-style-type: disc;

//     & li {
//       color: #f3d5d6;

//       & a {
//         display: block;
//         font-family: "Basier Circle", sans-serif;
//         color: #f3d5d6;
//         text-decoration: underline;
//         text-align: left;
//         font-weight: 600;
//         font-size: 1.2em;
//         line-height: 1.5em;
//         &:visited {
//           text-decoration: "none";
//         }
//         @media screen and (min-height: 769px) {
//           line-height: 1.2em;
//           font-size: 1.1em;
//         }
//       }
//     }
//   }
// `;

// const AlternativeHeading = styled.h4`
//   font-family: "Test Domaine Display", serif;
//   font-size: 1em;
//   text-align: left;
//   @media screen and (min-width: 1021px) {
//     font-size: 1.2em;
//   }
// `;

// markup

const IndexPage = (props) => {
  const { show = "slider" } = parse(props.location.search);
  console.log(show);
  // const screenWidth = useScreenWidth;
  const [popupEnabled, setpopupEnabled] = useState(false);
  const [popupImageName, setpopupImageName] = useState();
  const [popupData, setpopupData] = useState();
  const { screenWidth } = useScreenWidth();
  const [images, setImages] = useState({});

  const onHotspotClickHandler = (hotspotData) => {
    const { imageName, mobileImageName } = hotspotData;
    setpopupData(hotspotData);
    setpopupEnabled(true);
    setpopupImageName(screenWidth < 641 ? mobileImageName : imageName);
  };

  const bgImageDivRef = useRef();

  const { allFile } = useStaticQuery(graphql`
    {
      allFile(filter: { extension: { eq: "png" } }) {
        nodes {
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED)
          }
          name
        }
      }
    }
  `);

  useEffect(() => {
    const { nodes } = allFile;
    const newImages = new Object();
    nodes.forEach((d) => {
      newImages[d.name] = d.childImageSharp;
    });

    setImages(() => {
      return newImages;
    });
  }, []);

  useEffect(() => {
    const appHeight = () => {
      const doc = document.documentElement;
      doc.style.setProperty("--app-width", `${window.innerWidth * 0.01}px`);
      doc.style.setProperty("--app-height", `${window.innerHeight * 0.01}px`);
      if (bgImageDivRef.current) {
        bgImageDivRef.current.style.height = `${window.innerHeight}px`;
      }
    };
    window.addEventListener("resize", appHeight);
    appHeight();
  }, []);

  return (
    <>
      {Object.keys(images).length > 0 && (
        <BowerModal
          placeholderImages={{
            desktop: {
              ...images["pink_desktop"].gatsbyImageData,
            },
            tablet: {
              ...images["pink_tablet"].gatsbyImageData,
            },

            mobile: {
              ...images["pink_mobile"].gatsbyImageData,
            },
          }}
          popupData={popupData}
          popupEnabled={popupEnabled}
          setpopupEnabled={setpopupEnabled}
        ></BowerModal>
      )}
      {Object.keys(images).length && (
        <Container>
          {show === "slider" ? (
            <ImageSlider></ImageSlider>
          ) : show === "bathroom" ? (
            <BathroomImageWithHotspot
              images={images}
              onHotspotClick={onHotspotClickHandler}
            />
          ) : show === "laundry" ? (
            <LaundryImageWithHotspot
              images={images}
              onHotspotClick={onHotspotClickHandler}
            />
          ) : show === "kitchen" ? (
            <KitchenImageWithHotspot
              images={images}
              onHotspotClick={onHotspotClickHandler}
            />
          ) : (
            <CountDowns images={images} />
          )}
        </Container>
      )}
    </>
  );
};

export default IndexPage;
